import { LONG_TRANSLATION_KEY, SHORT_TRANSLATION_KEY } from './constants';

export const getTranslationKeyDefault = ( shortVersion = LONG_TRANSLATION_KEY ) =>
    shortVersion === SHORT_TRANSLATION_KEY
        ? 'shipping-time-default-short'
        : 'shipping-time-default';
